import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'parisDate',
  standalone: true
})
export class ParisDatePipe implements PipeTransform {
  private static readonly formatter = new Intl.DateTimeFormat('en-GB', {
    timeZone: 'Europe/Paris',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hourCycle: 'h23',
  });

  transform(value: string | number | Date | null | undefined, format: string = 'dd/MM/yyyy HH:mm:ss'): string {
    if (value === null || value === undefined || value === '') {
      return '';
    }

    const date = value instanceof Date ? value : new Date(value);

    if (isNaN(date.getTime())) {
      return '';
    }

    const parts = ParisDatePipe.formatter.formatToParts(date);
    const get = (type: string) => parts.find(part => part.type === type)?.value ?? '';

    const tokens: Record<string, string> = {
      yyyy: get('year'),
      dd: get('day'),
      MM: get('month'),
      HH: get('hour'),
      mm: get('minute'),
      ss: get('second'),
    };

    return format.replace(/yyyy|dd|MM|HH|mm|ss/g, token => tokens[token]);
  }
}
